<template>
    <router-link class="card-link" :to="{name: 'recipient', params: {slug: link}}">
    <li class="card lift-hover">
        <span class="thumbnailImage"
            :class="{'placeholder': imgIsPlaceholder}"
            :aria-label="imgAlt"
            :style="{ backgroundImage: `${thumbnailImage(model)}`}"
            role="img"
            >
        </span>
        <div class="text">
            <p class="cardHeader">{{ name(model) }}</p>
            <div class="info">
                <span class="field-label">{{ $t('labels.rank') }}</span>
                <span class="field">{{ model.NamTitle }}</span>

                <span class="field-label">{{ $t('labels.units') }}</span>
                <span class="field">{{ units(model) }}</span>

                <span class="field-label">{{ $t('labels.service_component') }}</span>
                <span class="field">{{ services(model) }}</span>
            </div>
        </div>
    </li>
    </router-link>
</template>

<script>
import {recipient_name} from '@/models/recipient.js'
import {recipient_thumbnail_image} from '@/models/recipient.js'
import {recipient_units} from '@/models/recipient.js'
import {recipient_services} from '@/models/recipient.js'

export default {
    name: "RecipientCard",
    props: {
        model: Object
    },
    computed: {
        imgIsPlaceholder(){
           return this.thumbnailImage(this.model).includes("baseline");
        },
        imgAlt() {
            let placeholderText = this.$i18n.t('recipients_page.card_placeholder_alt');
            let portraitText = `${this.$i18n.t('recipients_page.card_img_alt_prefix')} ${this.name(this.model)}`;

            return this.imgIsPlaceholder ? placeholderText : portraitText;
        },
        link(){
            if (this.model && this.model.irn){
                return this.model.irn
            }
            return "";
        }
    },
    methods: {
        name: (item => {
            return recipient_name(item)
        }),
        thumbnailImage: (item) => {
            return recipient_thumbnail_image(item)
        },
        units: (item => {
            return recipient_units(item)
        }),
        services: (item => {
            return recipient_services(item)
        })
    }
}
</script>

<style lang="scss" scoped>

.card {
    height: 512px;

  .thumbnailImage {
      background-color: #FFFFFF;

      &.placeholder {
        background-color: #edece8;
        opacity: .5;
    }
  }
}

.cardHeader {
    margin-top: 0;
}

.info {
    display: grid;
    grid-template-columns: 80px 150px;
    grid-template-rows: 40px 60px 60px;
    grid-template-rows: minmax(0px, 30px);
    grid-gap: 15px 8px;

    .field {
        margin-top: 0;
    }
}
</style>
